// Team Permission Levels: https://docs.deepsource.com/docs/access-control-managing-peoples-access-to-team-with-roles
// Repository Permission Levels: https://docs.deepsource.com/docs/access-control-managing-access-to-your-teams-repositories

import { defineComponent } from 'vue'
import { AppFeatures, RepoPerms } from '~/types/permTypes'
import { RepositoryCollaboratorPermission } from '~/types/types'
import ActiveUserMixin from './activeUserMixin'
import AuthMixin from './authMixin'
import RepoDetailMixin from './repoDetailMixin'

export interface RepoPermissions {
  canIgnoreIssues: boolean
  canModifyThresholds: boolean
  permission: RepositoryCollaboratorPermission
}

export default defineComponent({
  name: 'RoleAccessMixin',
  mixins: [RepoDetailMixin, AuthMixin, ActiveUserMixin],

  async fetch(): Promise<void> {
    if (this.$route.params.repo) {
      await this.fetchRepoPerms(this.baseRouteParams)
    }
  },

  computed: {
    repoPerms(): RepoPermissions {
      return {
        canIgnoreIssues: this.repository.userPermissionMeta?.can_ignore_issues,
        canModifyThresholds: this.repository.userPermissionMeta?.can_modify_metric_thresholds,
        permission: this.repository.userPermissionMeta?.permission
      }
    },

    hasRepoReadAccess(): boolean {
      if (this.repoPerms.permission) {
        return this.$gateKeeper.repo(RepoPerms.READ_REPO, this.repoPerms.permission)
      }
      return false
    },

    allowAutofix(): boolean {
      return this.$gateKeeper.provider(AppFeatures.AUTOFIX, this.activeProvider)
    },

    canEnableAutofix(): boolean {
      return this.$gateKeeper.repo(RepoPerms.INSTALL_AUTOFIX_APP, this.repoPerms.permission)
    }
  }
})
